// extracted by mini-css-extract-plugin
export default {"mCard":"HC-z","image":"IC-z","imageNoBackground":"JC-z","imageHasCategory":"KC-z","fullWidth":"LC-z"};